// Mapeamento centralizado de rotas do sistema
export const ROUTES = {
  ARENA_BAR: (slug: string) => `/arena/${slug}/bar`,
  ARENA_PDV: (slug: string) => `/arena/${slug}/pdv`,
  ARENA_ADQUIRENTES: (slug: string) => `/arena/${slug}/adquirentes`,
  ARENA_CONCILIACAO: (slug: string) => `/arena/${slug}/conciliacao`,
  ARENA_TERMINAIS: (slug: string) => `/arena/${slug}/terminais`,
  HOME: '/',
  AUTH: '/autenticacao',
  
  // Páginas de soluções (landing pages)
  SOLUCAO_TORNEIOS: '/solucao/torneios',
  SOLUCAO_ERP: '/solucao/erp-financeiro',
  SOLUCAO_ATLETA: '/solucao/portal-atleta',
  SOLUCAO_ARENAS: '/solucao/arenas',
  GESTAO_DE_ARENAS: '/gestao-de-arenas',
  RESET_PASSWORD: '/redefinir-senha',
  SELECT_ROLE: '/selecionar-perfil',
  DASHBOARD: '/painel',
  TOURNAMENTS: '/torneios',
  PUBLIC_TOURNAMENTS: '/torneios-publicos',
  
  TOURNAMENT_DETAILS: (slugOrId: string) => `/torneios/${slugOrId}`,
  TOURNAMENT_REGISTER: (slugOrId: string) => `/torneios/${slugOrId}/inscrever`,
  TOURNAMENT_REGISTRATIONS: (slugOrId: string) => `/torneios/${slugOrId}/inscricoes`,
  TOURNAMENT_CREATE: '/torneios/novo',
  TOURNAMENT_CREATE_FORM: '/torneios/criar',
  TOURNAMENT_EDIT: (slugOrId: string) => `/torneios/${slugOrId}/editar`,
  TOURNAMENT_MANAGE: (slugOrId: string) => `/torneios/${slugOrId}/gerenciar`,
  TOURNAMENT_MATCHES: (slugOrId: string) => `/torneios/${slugOrId}/jogos`,
  TOURNAMENT_PUBLIC_MATCHES: (slugOrId: string) => `/torneios/${slugOrId}/jogos-publicos`,
  TOURNAMENT_QUICK_SCORE: (slugOrId: string) => `/torneios/${slugOrId}/placar-rapido`,
  TOURNAMENT_BRACKET: (slugOrId: string) => `/torneios/${slugOrId}/chaves`,
  TOURNAMENT_EDIT_BRACKET: (slugOrId: string) => `/torneios/${slugOrId}/editar-chaves`,
  TOURNAMENT_STANDINGS: (slugOrId: string) => `/torneios/${slugOrId}/classificacao`,
  TOURNAMENT_AUDIT: (slugOrId: string) => `/torneios/${slugOrId}/auditoria`,
  TOURNAMENT_PREVIEW: (slugOrId: string) => `/torneios/${slugOrId}/preview`,
  TOURNAMENT_EXPENSES: (slugOrId: string) => `/torneios/${slugOrId}/despesas`,
  TEAMS: '/times',
  TEAM_CREATE: '/times/criar',
  /** URL canônica do time. Aceita slug (ex: /times/tubaroes-fc) ou UUID legado. */
  TEAM_PROFILE: (slugOrId: string) => `/times/${slugOrId}`,
  TEAM_EDIT: (slugOrId: string) => `/times/${slugOrId}/editar`,
  MY_REGISTRATIONS: '/minhas-inscricoes',
  REGISTRATION_CONFIRMATION: (registrationId: string) => `/inscricao-confirmacao/${registrationId}`,
  TRANSFER_HISTORY: '/historico-trocas',
  FAVORITES: '/favoritos',
  PARTNER_SEARCH: '/busca-duplas',

  // Ferramentas gratuitas públicas (sem login)
  TOOLS: '/ferramentas',
  TOOL_PAIR_DRAW: '/ferramentas/sorteio-de-duplas',
  TOOL_BRACKET: '/ferramentas/chaveamento',
  TOOL_LIVE_DRAW: (code: string) => `/ferramentas/ao-vivo/${code}`,
  PAYMENT_SUCCESS: '/pagamento-sucesso',
  COMPLETE_REGISTRATION: (linkId: string) => `/completar-inscricao/${linkId}`,
  ORGANIZER_DASHBOARD: '/painel-organizador',
  ORGANIZER_RECEIVABLES: '/organizador/recebimentos',
  ADMIN_PANEL: '/admin',
  ADMIN_BUDGET_TEMPLATES: '/admin/modelos-orcamento',
  ADMIN_CLASS_MODULE: '/admin/modulo-aulas',
  CREATE_ARENA: '/criar-arena',
  MINHAS_ARENAS: '/minhas-arenas',
  ARENA_DASHBOARD: (arenaSlug: string) => `/arena/${arenaSlug}`,
  ARENA_SESSAO: (arenaSlug: string, sessaoId: string) => `/arena/${arenaSlug}/sessao/${sessaoId}`,
  ARENA_TURMA_NOVA: (arenaSlug: string) => `/arena/${arenaSlug}/turma/nova`,
  ARENA_TURMA_DETALHE: (arenaSlug: string, turmaId: string) => `/arena/${arenaSlug}/turma/${turmaId}`,
  ARENA_TURMA_ALUNOS: (arenaSlug: string, turmaId: string) => `/arena/${arenaSlug}/turma/${turmaId}/alunos`,
  ARENA_TURMA_EDITAR: (arenaSlug: string, turmaId: string) => `/arena/${arenaSlug}/turma/${turmaId}/editar`,
  ARENA_MENSALISTAS: (arenaId: string) => `/arena/${arenaId}/mensalistas`,
  GLOBAL_RANKING: '/ranking-geral',
  ARENA_TURMAS: (arenaSlug: string) => `/arena/${arenaSlug}/turmas`,
  ARENA_TORNEIOS: (arenaSlug: string) => `/arena/${arenaSlug}/torneios`,
  ARENA_PLANO: (arenaSlug: string) => `/arena/${arenaSlug}/plano`,
  ATHLETE_PROFILE: (athleteId: string) => `/atleta/${athleteId}`,
  /** URL pública amigável do perfil do atleta (raiz, estilo Instagram). Use slug; cai no UUID legado se não houver. */
  PUBLIC_PROFILE: (slugOrId?: string | null, fallbackId?: string | null) =>
    slugOrId ? `/${slugOrId}` : (fallbackId ? `/atleta/${fallbackId}` : '/atleta'),
  /** URL pública raiz de time (estilo /tubaroes-fc). */
  PUBLIC_TEAM: (slug?: string | null, fallbackId?: string | null) =>
    slug ? `/${slug}` : (fallbackId ? `/times/${fallbackId}` : '/times'),
  /** URL pública raiz de arena. */
  PUBLIC_ARENA: (slug?: string | null) => slug ? `/${slug}` : '/',
  ATHLETE_PORTAL: '/atleta',
  ATHLETE_RESERVAS: '/atleta/reservas',
  ATHLETE_AULAS: '/atleta/aulas',
  ATHLETE_JOGOS: '/atleta/jogos',
  ATHLETE_INSCRICOES: '/atleta/inscricoes',
  ATHLETE_FINANCEIRO: '/atleta/financeiro',
  ATHLETE_NOTIFICACOES: '/atleta/notificacoes',
  ATHLETE_RANKING: '/atleta/ranking',
  ATHLETE_HISTORICO: '/atleta/historico',
  ATHLETE_TIMES: '/atleta/times',
  EXPLORE: '/explorar',
  ATHLETE_TIME_CREATE: '/atleta/times/criar',
  MY_ATHLETE_PROFILE: '/meu-perfil-atleta',
  ADMIN_RANKING_CONFIG: '/admin/configuracao-ranking',
  FOR_ORGANIZERS: '/para-organizadores',
  ORGANIZER_PLAN: '/plano-organizador',
  ORGANIZER_SIGNUP: '/cadastro-organizador',
  FEATURES: '/funcionalidades',
  TERMS_OF_USE: '/termos-de-uso',
  REFUND_POLICY: '/politica-de-reembolso',
  PRIVACY_POLICY: '/politica-de-privacidade',
  VERIFY_DEVICE: '/verify-device',
  CLASS_CHECKIN: (encoded: string) => `/checkin/${encoded}`,
  PUBLIC_BOOKING: (slug: string) => `/reservar/${slug}`,
  PWA_INSTALL: '/instalar',
  ARENA_CHECKIN: (arenaSlug: string) => `/arena/${arenaSlug}/checkin-aulas`,
  ARENA_IDENTITY_CLAIMS: (arenaSlug: string) => `/arena/${arenaSlug}/identidade-reivindicacoes`,
  ADMIN_IDENTITY_DISPUTES: '/admin/identity-disputes',
  ADMIN_COMMUNITY_REPORTS: '/admin/community/reports',
  ACCOUNT_IDENTITY: '/conta/identidade',
  ACCEPT_TOURNAMENT_MANAGER: (token: string) => `/aceitar-co-gestor?token=${token}`,
  ACCEPT_ARENA_INVITE: (token: string) => `/aceitar-convite?token=${token}`,
  ARENA_CLIENTE_FICHA: (arenaSlug: string, personId: string) => `/arena/${arenaSlug}/cliente/${personId}`,
  ARENA_OPERACAO: (arenaSlug: string) => `/arena/${arenaSlug}/operacao`,
  ARENA_NOTIFICACOES: (arenaSlug: string) => `/arena/${arenaSlug}/notificacoes`,
  ARENA_CONTRATOS: (arenaSlug: string) => `/arena/${arenaSlug}/contratos`,
  ARENA_UNIFORMES: (arenaSlug: string) => `/arena/${arenaSlug}/uniformes`,
  UNIFORM_PRESALE: (arenaSlug: string, campaignSlug: string) => `/uniformes/${arenaSlug}/${campaignSlug}`,
  UNIFORM_ORDER: (token: string) => `/uniformes/pedido/${token}`,
  ARENA_CONTRATO_DETALHE: (arenaSlug: string, contractId: string) => `/arena/${arenaSlug}/contratos/${contractId}`,

  // Portal Comercial (vendedor, afiliado, parceiro, closer)
  COMMERCIAL_PORTAL: '/comercial',
  COMMERCIAL_SALES: '/comercial/vendas',
  COMMERCIAL_COMMISSIONS: '/comercial/comissoes',
  // Aliases legados — mantidos para compatibilidade; redirecionam via App.tsx
  AFFILIATE_PORTAL: '/afiliado',
  AFFILIATE_SALES: '/afiliado/vendas',
  AFFILIATE_COMMISSIONS: '/afiliado/comissoes',
  // Página pública de venda assistida (token gerado pela RPC create_assisted_sale)
  COMMERCIAL_CHECKOUT: (token: string) => `/checkout/comercial/${token}`,
};

/**
 * Gera um link público de indicação (referral) para um afiliado.
 * Ex.: https://velloplay.com/?ref=JOAO123
 */
export function buildReferralLink(referralCode: string, baseUrl?: string): string {
  const base = baseUrl ?? (typeof window !== 'undefined' ? window.location.origin : 'https://velloplay.com');
  return `${base.replace(/\/$/, '')}/?ref=${encodeURIComponent(referralCode.toUpperCase())}`;
}
